import React from 'react'

const TableDesign = (props: any) => {
    return (
        <div className="overflow-x-auto relative shadow-md sm:rounded-lg">
            <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                    <tr>

                        {props.thead.map((item: string, i: any) => (
                            <th key={i} scope="col" className="py-3 px-6">
                                {item}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {props.children}

                </tbody>
            </table>
        </div>
    )
}

export default TableDesign